import * as React from 'react'
import * as SwitchPrimitive from '@radix-ui/react-switch'
import { clsx } from 'clsx'

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>
>(({ children, className, ...rest }, ref) => (
  <SwitchPrimitive.Root
    ref={ref}
    className={clsx(
      className,
      'w-8 h-[18px] bg-dark-shade rounded-full focus-visible:outline-1 focus-visible:outline-dark-control-base relative border border-dark-elevated outline-none cursor-default',
      'radix-state-checked:bg-dark-accent/15 radix-state-checked:border-dark-accent'
    )}
    {...rest}
  >
    {children}
  </SwitchPrimitive.Root>
))

Switch.displayName = SwitchPrimitive.Root.displayName

const SwitchThumb = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitive.Thumb>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Thumb>
>(({ className, ...props }, ref) => (
  <SwitchPrimitive.Thumb
    ref={ref}
    {...props}
    className={clsx(
      className,
      'block size-3 bg-dark-faint rounded-full duration-100 translate-x-0.5 transition-[transform,background-color] will-change-transform radix-state-checked:translate-x-4 radix-state-checked:bg-dark-accent'
    )}
  />
))

SwitchThumb.displayName = SwitchPrimitive.Thumb.displayName

export { Switch, SwitchThumb }
